module.exports = __webpack_public_path__ + "img/type-mexico.a17aaf97.png";